import { TITLE_BLOCK_W, TITLE_BLOCK_H } from "./constants";

interface TitleBlockProps {
  partNumber: string;
  revision: string;
  name: string;
  date: string;
  scale: string;
  x: number;
  y: number;
}

export default function TitleBlock({
  partNumber,
  revision,
  name,
  date,
  scale,
  x,
  y,
}: TitleBlockProps) {
  const w = TITLE_BLOCK_W;
  const h = TITLE_BLOCK_H;
  const rowH = h / 3;
  const fontSize = 3.5;
  const labelSize = 2.5;
  const col1 = 50;
  const col2 = 100;
  const col3 = 140;

  return (
    <g className="title-block" transform={`translate(${x}, ${y})`}>
      {/* Outer border */}
      <rect
        x={0}
        y={0}
        width={w}
        height={h}
        fill="none"
        stroke="#000"
        strokeWidth={0.5}
      />

      {/* Row dividers */}
      <line x1={0} y1={rowH} x2={w} y2={rowH} stroke="#000" strokeWidth={0.3} />
      <line x1={0} y1={rowH * 2} x2={w} y2={rowH * 2} stroke="#000" strokeWidth={0.3} />

      {/* Column dividers — row 1 */}
      <line x1={col1} y1={0} x2={col1} y2={rowH} stroke="#000" strokeWidth={0.3} />
      <line x1={col2} y1={0} x2={col2} y2={rowH} stroke="#000" strokeWidth={0.3} />
      <line x1={col3} y1={0} x2={col3} y2={rowH} stroke="#000" strokeWidth={0.3} />

      {/* Column dividers — row 2 */}
      <line x1={col2} y1={rowH} x2={col2} y2={rowH * 2} stroke="#000" strokeWidth={0.3} />

      {/* Row 1: Company | Drawn By | Date | Scale */}
      <text x={2} y={4} fontSize={labelSize} fontFamily="monospace" fill="#666">
        COMPANY
      </text>
      <text x={2} y={10} fontSize={fontSize} fontFamily="monospace" fill="#000" fontWeight="bold">
        Ledo Engineering
      </text>

      <text x={col1 + 2} y={4} fontSize={labelSize} fontFamily="monospace" fill="#666">
        DRAWN BY
      </text>
      <text x={col1 + 2} y={10} fontSize={fontSize} fontFamily="monospace" fill="#000">
        —
      </text>

      <text x={col2 + 2} y={4} fontSize={labelSize} fontFamily="monospace" fill="#666">
        DATE
      </text>
      <text x={col2 + 2} y={10} fontSize={fontSize} fontFamily="monospace" fill="#000">
        {date}
      </text>

      <text x={col3 + 2} y={4} fontSize={labelSize} fontFamily="monospace" fill="#666">
        SCALE
      </text>
      <text x={col3 + 2} y={10} fontSize={fontSize} fontFamily="monospace" fill="#000">
        {scale}
      </text>

      {/* Row 2: Description | Revision */}
      <text x={2} y={rowH + 4} fontSize={labelSize} fontFamily="monospace" fill="#666">
        DESCRIPTION
      </text>
      <text x={2} y={rowH + 10} fontSize={fontSize} fontFamily="monospace" fill="#000">
        {name}
      </text>

      <text x={col2 + 2} y={rowH + 4} fontSize={labelSize} fontFamily="monospace" fill="#666">
        REVISION
      </text>
      <text
        x={col2 + 2}
        y={rowH + 10}
        fontSize={fontSize + 1}
        fontFamily="monospace"
        fill="#000"
        fontWeight="bold"
      >
        {revision}
      </text>

      {/* Row 3: Part Number (full width) */}
      <text x={2} y={rowH * 2 + 4} fontSize={labelSize} fontFamily="monospace" fill="#666">
        PART NUMBER
      </text>
      <text
        x={2}
        y={rowH * 2 + 10}
        fontSize={fontSize + 1}
        fontFamily="monospace"
        fill="#000"
        fontWeight="bold"
      >
        {partNumber}
      </text>
    </g>
  );
}
